import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Afiliaciones } from '../../../../models/afiliaciones';
import { ConfigDataService } from '../../../../services/config-data.service';
import { PersonalService } from '../../../../services/personal.service';
import { ClaseAfiliacionService } from '../../../../services/claseAfiliacion.service';
import {MyValidations} from '../../../../utils/my-validations';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-afiliaciones-detalle',
  templateUrl: './afiliaciones-detalle.component.html',
  styleUrls: ['./afiliaciones-detalle.component.css']
})
export class AfiliacionesDetalleComponent implements OnInit, AfterViewInit {
    
  constructor(private configDataSrv: ConfigDataService,
              private fb: FormBuilder, 
              private personalService: PersonalService) { }

  @Input() set afiliacion(afiliacionRecibida: Afiliaciones)
  {
    this.afiliacionForm = afiliacionRecibida;
    this.setearForm(afiliacionRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() afiliacionInvalida: boolean;

  form: FormGroup;
  afiliacionForm: Afiliaciones;
  actualizarFormatoInputNumerico = false;
  submitted: boolean;
  clasesAfiliacionList: any;
  tipoCarga: number;
  formHabilitado: boolean;
  MensajeRetro = "";

  ngOnInit(): void
  {
    this.tipoCarga = 0;

    this.configDataSrv.getDatosAfiliaciones()
      .subscribe(
        data => {
          this.clasesAfiliacionList=data;
        },
        error => {
          console.log(error);
        });

    this.configurarValidadores();
    this.setearForm(this.afiliacionForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      claseAfiliaciones: ['', Validators.required],
      descripcion: ['', Validators.required]
    });

  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(afiliacion: Afiliaciones)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(afiliacion?.id);
      this.form.controls['desde'].setValue(new Date(afiliacion?.desde));
      this.form.controls['hasta'].setValue(new Date(afiliacion?.hasta));
      this.form.controls['personal'].setValue(afiliacion?.personal);
      this.form.controls['claseAfiliaciones'].setValue(afiliacion?.claseAfiliaciones);
      this.form.controls['descripcion'].setValue(afiliacion?.descripcion);

      if (afiliacion.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
      this.chequeoRetro();
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
      this.formHabilitado = habilitado;
    }
  }

  ngAfterViewInit()
  {
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  onChangeFechas()
  {
    this.chequeoRetro();
  }

  chequeoRetro()
  {
    this.MensajeRetro = "";
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    
    this.personalService.ChequeoRetroactividad(this.afiliacionForm.personal, 'Afiliaciones', desde, hasta, true).subscribe(
      data =>
      {
        let resul = data;
        if (resul.haceRetro)
        {
          let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
          this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
        }
      }
    );
  }
}

